import React from "react";
import ClassCardLogo from "../../assets/img/classcard.svg";
import { setBoardInfo } from "../../utils/authentication-access";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { CLASSES } from "../../utils/url-builder";
import { del } from "../../utils/api-authentication";
import { getClassInfo } from "../../utils/authentication-access";
import closeLogo from '../../assets/img/closeIcon.svg';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Snackbar from "@material-ui/core/Snackbar";


class DownloadCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            optionopen: false,
            optionanchorEl: null,
            dialogBox: false,
            pdfUrl:''
        };
    }


   
    documentDialogClose = () => {
        this.setState({
            dialogBox:false
        })
    };
    documentDialogOpen=()=>{
        this.setState({dialogBox:true})
    }
    openOptionSettings = event => {
        event.stopPropagation();
        this.setState({ optionopen: !this.state.optionopen });
        this.setState({ optionanchorEl: event.currentTarget });
    }

 

    componentDidMount(){
        this.setState({
            pdfUrl: 'https://docs.google.com/viewer?url=' + this.props.file.url + '&pid=explorer&efh=false&a=v&chrome=false&embedded=true',

        });
    }

    closeOptions = (event) => {
        event.stopPropagation();
        this.setState({ optionopen: false });
    }
    
    render() {
        return (
            <>
            <div className="classcard-grid" onClick={this.documentDialogOpen}>
                <div className="classcard-img" style={{ textAlign: 'center' }}>
                    <img className="classlogo" src={'/pdf.png'} alt="File" style={{ width: '65%', height: '95%' }} />
                </div>
                <div className='classcard-footer'>
                    <div className="classcard-groupname">{this.props.file.name}</div>
                    {/* <MoreVertIcon style={{ color: '#677786' }} onClick={this.openOptionSettings} /> */}
                </div>
                {/* <Menu
                    onClose={this.closeOptions}
                    open={this.state.optionopen}
                    anchorEl={this.state.optionanchorEl} >
                    <MenuItem onClick={this.downloadPdf.bind(this, this.props.file.url)}>Download</MenuItem>
                </Menu> */}


            </div>
                <Dialog

                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    open={this.state.dialogBox}
                    onClose={this.documentDialogClose}
                    maxWidth
                    
                >
                    {/* <div className="dialog-modal-header bg-primary">

                        <div className="text-center">
                            <img className='close-icon hover' src={closeLogo} alt='Close' onClick={this.documentDialogClose} />
                        </div>
                    </div> */}
                    <iframe style={{ width: '50vw', height: '60vh' }} src={this.state.pdfUrl}></iframe>

                </Dialog>
            </>
        );
    }
}

export default DownloadCard;
